import React, { useEffect, useRef, useState } from "react";
import Header from "../../layout/Header";
import { ValidatorForm } from "react-form-validator-core";
import { postKYCData, updateCustomer, updateKYCData, } from "../../../../actions/auth";
import swal from "sweetalert";
import CustomPagination from "../../partial/CustomPagination"
import { getKYCData } from "../../../../components/pages/campaigns/services";
import { COLUMNS } from "./column";
import { Link } from "react-router-dom";
import { downloadIcon } from "../../../../Image/Index";
import SampleFile from "./sample.csv"

const KYC = () => {
    const [loader, setLoader] = useState(false);
    const [state, setState] = useState({
        file: "",
        error: true,
        errorMsg: "Note:- Only .csv type files are supported.",
    });
    const [currentPage, setCurrentPage] = useState(0);
    const [response, setResponse] = useState([]);
    const [editRowId, setEditRowId] = useState(null);
    const [editData, setEditData] = useState({});

    const { file, error, errorMsg } = state;
    const pageSize = 10;
    const pageCount = Math.ceil(response?.length / pageSize);

    const fileInputRef = useRef(null);

    const onChange = (e) => {
        if (e.target.files[0]?.type?.includes("csv")) {
            setState({ ...state, file: e.target.files[0], error: false });
        } else {
            setState({ ...state, error: true });
        }
    };

    const fetchKYCList = async () => {
        setLoader(true);
        const token = JSON.parse(localStorage.getItem("token_gen"));
        const Id = (localStorage.getItem("Id"));
        try {
            const res = await getKYCData(token?.access_token, Id, 0, 50, " ");
            if (res.message === "success") {
                const tempData = res?.data?.data?.filter((ele) =>
                    ele.customerData?.isVerified?.toString() === "false"
                )
                setResponse(tempData)

            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoader(false);
        }
    };
    useEffect(() => {
        fetchKYCList();
    }, []);

    const onSubmit = async () => {
        if (file) {
            const token = JSON.parse(localStorage.getItem("token_gen"));
            const Id = (localStorage.getItem("Id"));
            setLoader(true);
            try {
                await postKYCData(file, token?.access_token, Id).then((res) => {
                    if (res.message == "Customer KYC upload successful.") {
                        fileInputRef.current.value = "";
                        setState({
                            file: "",
                            error: false,
                            errorMsg: "Note:- Only .csv type files are supported.",
                        });
                        fetchKYCList();
                        swal({
                            position: "center",
                            icon: "success",
                            title: "KYC data uploaded successfully",
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    } else {
                        swal({
                            position: "center",
                            icon: "error",
                            title: "KYC data not uploaded ",
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    }
                })

            } catch (err) {
                console.error(err);
            } finally {
                setLoader(false);
            }
        } else {
            setState({ ...state, error: true, errorMsg: "Please upload a file" });
        }
    };

    const handleEdit = (customercode) => {
        const data = response.find((item) => item?.customerData?.customercode === customercode);
        setEditRowId(customercode);
        setEditData(data);
    };

    const handleInputChange = (key, value) => {
        setEditData((prev) => ({ ...prev, [key]: value }));
    };

    const handleSave = async () => {
        setLoader(true)
        const token = JSON.parse(localStorage.getItem("token_gen"));
        try {
            const body = {
                isVerified: editData?.isVerified,
                remark: editData?.remark,
                cpkycstatus: editData?.isVerified === "true" ? "Approved" : "Reject"
            }
            await updateCustomer(token?.access_token, editRowId, body,).then((res) => {
                if (res.message == "Request processed successfully.") {
                    setEditRowId(null);
                    setLoader(false)
                    swal({
                        position: "center",
                        icon: "success",
                        title: "KYC data updated successfully",
                        showConfirmButton: false,
                        timer: 3000,
                    });
                    fetchKYCList();
                }
                else {
                    swal({
                        position: "center",
                        icon: "error",
                        title: "KYC data not updated",
                        showConfirmButton: false,
                        timer: 3000,
                    });
                }
            })

        } catch (err) {
            console.error(err);

        } finally {
            setLoader(false);
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        return date.toLocaleDateString("en-GB"); // DD-MM-YYYY
    };
    const handleCancel = () => {
        setEditRowId(null);
        setEditData({});
    };

    return (
        <>
            <Header name={"KYC Management"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        {[...Array(8)].map((_, i) => (
                            <div key={i}></div>
                        ))}
                    </div>
                </div>
            )}
            <div className='dashboard__content'>
                <ValidatorForm onSubmit={onSubmit} className="dashboard__customerViewMain">
                    <div className="dashboard__transactionsCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>Upload KYC</h4>
                            </div>
                            <div className="dashboard__right">
                                <Link to={SampleFile} className="btn btn-primary" style={{ gap: '8px' }} download="KYCSampleFile" target="_blank">
                                    Download our sample file <i className="fa-solid fa-download"></i>
                                </Link>
                            </div>
                        </div>
                        <div className='dashboard__customerViewCard'>
                            <div className='row'>
                                <div className="col-md-4">
                                    <div className="uploadingExistingData__uploadBoxUploadFile">
                                        <form encType="multipart/form-data">
                                            <input
                                                ref={fileInputRef}
                                                className="form-control"
                                                placeholder="Uploaded File"
                                                type="file"
                                                accept=".csv"
                                                onChange={onChange}
                                            />
                                            {error && <span style={{ color: "red" }}>{errorMsg}</span>}
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className='customer_group_form'>
                                <button type='submit' className="btn btn-primary">
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </ValidatorForm>

                <div className="dashboard__customersCard">
                    <div className="dashboard__header">
                        <div className="dashboard__left">
                            <h4>KYC List</h4>
                        </div>
                    </div>
                    <div className="dashboard__body">
                        {Array.isArray(response) && response.length > 0 ? (
                            <div>
                                <div style={{ overflowX: "auto" }}>
                                    <table className="table table-bordered" style={{ minWidth: "1000px" }}>
                                        <thead>
                                            <tr>
                                                <th>Code</th>
                                                <th>Aadhar Card</th>
                                                <th>Pan Card</th>
                                                <th>Gst No.</th>
                                                <th>Name</th>
                                                <th>DOB</th>
                                                <th>Email</th>
                                                <th>Mobile</th>
                                                <th>Store Address</th>
                                                <th>Is Verified</th>
                                                <th>Remark</th>
                                                <th style={{ position: "sticky", zIndex: 5, right: 0, background: "white" }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {response
                                                .slice(currentPage * pageSize, (currentPage + 1) * pageSize)
                                                .map((item, ind) => {
                                                    const data = item.customerData;

                                                    const codeKey =
                                                        data.adminid
                                                            ? "adminid"
                                                            : data.influencercode
                                                                ? "influencercode"
                                                                : data.customerid
                                                                    ? "customerid"
                                                                    : data.retailercode
                                                                        ? "retailercode"
                                                                        : data.distributorcode
                                                                            ? "distributorcode"
                                                                            : "";

                                                    return (
                                                        <tr key={ind}>
                                                            <td><Link to={`/channel-partner/user-view/${data?.customercode}`}>{data[codeKey]}</Link></td>
                                                            {[
                                                                "aadharcard",
                                                                "pancard",
                                                                "gstno",
                                                                "name",
                                                                "dob",
                                                                "email",
                                                                "mobile",
                                                                "location",
                                                                "isVerified",
                                                                "remark"
                                                            ].map((key) => (
                                                                <td key={key}>
                                                                    {editRowId === data.customercode && (key === "isVerified" || key === "remark") ? (
                                                                        key === "remark" ? (
                                                                            <input
                                                                                className="editData"
                                                                                value={editData[key] || ""}
                                                                                onChange={(e) => handleInputChange(key, e.target.value)}
                                                                            />
                                                                        ) : key === "isVerified" ? (
                                                                            <select
                                                                                value={editData[key] || "false"}
                                                                                onChange={(e) => handleInputChange(key, e.target.value)}
                                                                            >
                                                                                <option value="true">True</option>
                                                                                <option value="false">False</option>
                                                                            </select>
                                                                        ) : null
                                                                    ) : typeof data[key] === "object" && data[key] !== null ? (
                                                                        JSON.stringify(data[key])
                                                                    ) : (
                                                                        data[key]
                                                                    )}
                                                                </td>
                                                            ))}

                                                            <td style={{ position: "sticky", zIndex: 1, right: 0, background: "white" }}>
                                                                {editRowId === data.customercode ? (
                                                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                                                        <button className="btn btn-sm btn-success" onClick={handleSave}>
                                                                            Approved
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-sm btn-danger"
                                                                            onClick={handleCancel}
                                                                            style={{ marginLeft: "5px" }}
                                                                        >
                                                                            Reject
                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                                                        <button
                                                                            className="btn btn-sm btn-outline-primary"
                                                                            onClick={() => handleEdit(data.customercode)}
                                                                        >
                                                                            Edit
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}

                                        </tbody>
                                    </table>
                                </div>
                                <div className="dashboard__paginationBox mt-2">
                                    <CustomPagination currentPage={currentPage} setCurrentPage={setCurrentPage} pageCount={pageCount} value={5} />
                                </div>
                            </div>
                        ) : (
                            <p className="text-center">No data found</p>
                        )}

                    </div>
                </div>
            </div>
        </>
    );
};

export default KYC;
